import { defineComponent, ref } from 'vue';
import VideoListComponent from '@/components/videoList/VideoList.vue';
import VideoFormComponent from '@/components/videoList/videoForm/VideoForm.vue';

export default defineComponent({
  name: 'VideoPage',
  components: {
    VideoListComponent,
    VideoFormComponent
  },
  setup: () => {
    const selectedVideoId = ref<number | null>();
    const videoForm = ref<InstanceType<typeof VideoFormComponent>>();

    const createClick = () => {
      Promise.resolve(selectedVideoId.value = null)
        .then(() => videoForm.value?.show());
    };

    const editClick = (carouselId: number) => {
      Promise.resolve(selectedVideoId.value = carouselId)
        .then(() => videoForm.value?.show());
    };

    return {
      selectedVideoId,
      videoForm,
      createClick,
      editClick,
    };
  },
});
